import { render, staticRenderFns } from "./VehicleBrandModal.vue?vue&type=template&id=5a892c05"
import script from "./VehicleBrandModal.vue?vue&type=script&lang=js"
export * from "./VehicleBrandModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports